<template>
  <div style="padding:100px 8%;">
    <div class="tab-pane pt-3 active show">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-2">
            <h4>試算公式</h4>
          </div>
          <div class="col-10 text-right">
            <a class="btn btn-default top-button" @click="formulaMantain()"
              >公式設定
            </a>
            <a
              class="btn btn-default top-button"
              @click="
                $router.push({
                  name: 'ProductMenuPage',
                  params: { isback: true },
                })
              "
              >回商品維護
            </a>
          </div>
          <div class="col-12 text-right" v-if="productData">
            <span>
              公  司: 
              <span class="font-weight-bold">{{productData.company.COMPSNM}}</span>
              <span class="font-weight-bold">{{" " + getProductTypeName(productData.productType)}}</span>
              險種種類:
              <span class="font-weight-bold">{{getContractTypeName(productData.contractType)}}</span>
              商品名稱:
              <span class="font-weight-bold">{{productData.insuranceName}}</span>
              <span class="font-weight-bold" v-if="productData.insuranceCode">({{productData.insuranceCode}})</span>
            </span>
          </div>
          <div class="col-12">
            <form class="form">
              <div class="panel panel-form searchArea">
                <h4 class="text-green text-center">檢核條件</h4>

                <!-- 計劃別 -->
                <div class="form-group row" v-if="showScheme">
                  <label class="col-2 text-right">計劃別</label>
                  <div class="col-9">
                    <div
                      v-for="(item, i) in schemeList"
                      :key="`scheme-data-${i}`"
                      class="radio radio-inline ml-5"
                    >
                      <input
                        type="radio"
                        :id="`scheme-${i}`"
                        :value="item.value"
                        v-model="schemeId"
                        @change="schemeChange()"
                      />
                      <label :for="`scheme-${i}`">{{ item.text }}</label>
                    </div>
                  </div>
                </div>

                <!-- 繳費年期 -->
                <div class="form-group row">
                  <label class="col-2 text-right">繳費年期</label>
                  <div class="col-9">
                    <div
                      v-for="(item, i) in coverageAnnuals"
                      :key="`yearPeriod-data-${i}`"
                      class="checkbox radio-inline ml-5"
                    >
                      <input
                        type="checkbox"
                        :id="`yearPeriod-${i}`"
                        :value="item.value"
                        v-model="yearPeriod"
                      />
                      <label :for="`yearPeriod-${i}`">{{ item.text }}</label>
                    </div>
                  </div>
                </div>

                <!-- 檢核內容 -->
                <div class="form-group row">
                  <label class="col-2 text-right">檢核內容</label>
                  <template v-for="(item, i) in coverageList">
                    <div
                      class="col-2"
                      v-if="i && i % 3 == 0"
                      :key="`outter-${i}`"
                    />
                    <div class="col-3" :key="`inner-${i}`">
                      <div class="checkbox radio-inline ml-5">
                        <input
                          type="checkbox"
                          :id="`quotaType-${i}`"
                          :value="item.name"
                          v-model="coverageId"
                          @change="coverageChange()"
                        />
                        <label :for="`quotaType-${i}`">{{ item.name }}</label>
                      </div>
                    </div>
                  </template>
                </div>

                <!-- 投保年齡 -->
                <div class="form-group row">
                  <label class="col-2 text-right">投保年齡</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="3"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': validate.isAgeNumberErr }"
                      v-model="ageTextBox"
                    />
                    <label class="lh-40">歲</label>
                  </div>
                </div>

                <!-- 投保金額 -->
                <div class="form-group row">
                  <label class="col-2 text-right">投保金額</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if (this.value.match(/^\d{0,9}(\.?\d{0,6})/g)[0] !== this.value ) this.value = this.value.match(/^\d{0,9}(\.?\d{0,6})/g)[0];"
                      maxlength="9"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': validate.isAmountNumberErr }"
                      :disabled="showScheme"
                      v-model="amountTextBox"
                    />
                    <label class="lh-40">{{ amountUnitLabel }}</label>
                  </div>
                </div>

                <!-- 保費 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保費</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': validate.isPremiumNumberErr }"
                      v-model="premiumTextBox"
                    />
                    <label class="lh-40">{{ premiumUnitLabel }}</label>
                  </div>
                </div>

                <!-- 保單價值 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保單價值</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="insuranceValueTextBox"
                    />
                    <label class="lh-40">{{ policyValueUnitLabel }}</label>
                  </div>
                </div>

                <!-- 單位數 -->
                <div class="form-group row">
                  <label class="col-2 text-right">單位數</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="unitNoTextBox"
                    />
                  </div>
                </div>

                <!-- 保證最低身故金額 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保證最低身故金額</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="minGuaranteeDieAmountTextBox"
                    />
                    <label class="lh-40">{{ minGuaranteeDieAmountUnitLabel }}</label>
                  </div>
                </div>

                <!-- 保證最低滿期金額 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保證最低滿期金額</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="minGuaranteeDueMoneyTextBox"
                    />
                    <label class="lh-40">{{ minGuaranteeDueMoneyUnitLabel }}</label>
                  </div>
                </div>

                <!-- 年金給付日 -->
                <div class="form-group row" v-if="this.productData.productType == '3'">
                  <label class="col-2 text-right">年金給付日</label>
                  <div class="col-9">
                    <date-picker
                        v-model="annuityPayDate"
                        :format="dashDateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1"
                        :class="{ 'is-invalid': validate.isAnnuityPayDateErr }" />
                  </div>
                </div>

                <!-- 保險金扣除額 -->
                <div class="form-group row">
                  <label class="col-2 text-right">保險金扣除額</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="deductionAmountTextBox"
                    />
                    <label class="lh-40">{{ deductionAmountUnitLabel }}</label>
                  </div>
                </div>

                <!-- 總繳保險費 -->
                <div class="form-group row">
                  <label class="col-2 text-right">總繳保險費</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="totalPremiumPaidTextBox"
                    />
                    <label class="lh-40">{{ totalPremiumPaidUnitLabel }}</label>
                  </div>
                </div>

                <!-- 部分提領金額 -->
                <div class="form-group row">
                  <label class="col-2 text-right">部分提領金額</label>
                  <div class="col-9">
                    <input
                      type="number"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/\./g,'');"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-model="partialWithdrawalAmountTextBox"
                    />
                    <label class="lh-40">{{ partialWithdrawalAmountUnitLabel }}</label>
                  </div>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="clickCheck()"
                  >
                    檢核
                  </button>
                </div>
              </div>
            </form>
        </div>

        <div class="col-12" v-show="Object.keys(calculateTable).length">
          <h4 class="text-green text-center">{{ yearPeriod.length ? "檢核結果" : "無符合條件的保障公式" }}</h4>
        </div>
        <div 
          class="col-12"
          v-for="(years, i) in yearPeriod"
          :key="`yearPeriod-data-${i}`"
          v-show="Object.keys(calculateTable).length"
        >
          <h5 class="text-left text-green">
            繳費年期 : 
            {{
              years.includes("@")
                ? parseInt(years).toString().padStart(2, "0") + "歲"
                : parseInt(years).toString().padStart(2, "0")
            }}
          </h5>
          <table class="table datatable">
            <thead>
              <tr>
                <th width="100" class="text-center">年齡</th>
                <th width="100" class="text-center">年度</th>
                <th width="100" class="text-center">民國年</th>
                <template
                  v-for="(item, j) in coverageList.filter((each) =>
                    coverageId.includes(each.name)
                  )"
                >
                  <th width="100" class="text-center" :key="`coverage-col-${j}`">
                    {{ item.name }}
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rowdata, k) in calculateTable[years]" :key="`tradition-data-${k}`">
                <template
                  v-for="(coldata, l) in rowdata"
                >
                  <td class="text-center" :key="`coverage-data-${l}`" v-html="`${coldata}${l > 2 && coldata != '' ? hiddenDisplayCurrencyText : ''}`"></td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12" v-show="!Object.keys(calculateTable).length && showResult">
          <h4 class="text-green text-center">無符合條件的保障公式</h4>
        </div>

      </div>
    </div>
    </div>
    <mv-mask :open="mvMaskOpen" :content="mvMaskContent" />
  </div>
</template>

<script>
import {
  getInvestFormulaSummary,
  calculateCoverage,
} from "@/service";
import MvMask from "@/desktop/views/mv/components/mvMask";
import DatePicker from '@/components/DatePicker/components/Datepicker'
import { commonMixin } from '@/mixins/common';
import moment from "moment";
import { zh } from "@/components/DatePicker/locale";
export default {
  name: "InvestCoverageFormulaValidation",
  components: {
    DatePicker,
    MvMask,
  },
  mixins: [commonMixin],
  data() {
    return {
      calculateTable: [],
      showResult: false,
      productData: [],
      schemeList: [],
      coverageAnnuals: [],
      coverageList: [],
      currencyList: [],
      showScheme: false,
      schemeId: "",
      yearPeriod: [],
      coverageId: [],
      currencyId: "",
      hiddenDisplayCurrencyText: "",
      ageTextBox: "",
      amountTextBox: "",
      premiumTextBox: "",
      insuranceValueTextBox: "",
      unitNoTextBox: "",
      minGuaranteeDieAmountTextBox: "",
      minGuaranteeDueMoneyTextBox: "",
      deductionAmountTextBox: "",
      totalPremiumPaidTextBox: "",
      partialWithdrawalAmountTextBox: "",
      annuityPayDate: "",
      dateLang: zh,
      amountUnitLabel: "元",
      premiumUnitLabel: "元",
      policyValueUnitLabel: "元",
      minGuaranteeDieAmountUnitLabel: "元",
      minGuaranteeDueMoneyUnitLabel: "元",
      deductionAmountUnitLabel: "元",
      totalPremiumPaidUnitLabel: "元",
      partialWithdrawalAmountUnitLabel: "元",
      validate: {
        isAgeNumberErr: false,
        isAmountNumberErr: false,
        isPremiumNumberErr: false,
        isAnnuityPayDateErr: false,
      },
      options: {
        productType: [
          {
            name: "傳統型",
            value: "1",
          },
          {
            name: "投資型",
            value: "2",
          },
          {
            name: "利率變動型",
            value: "3",
          },
          {
            name: "傳統型(取大)",
            value: "4",
          },
        ],
        contractType: [
          {
            name: "主約",
            value: "1",
          },
          {
            name: "附約",
            value: "2",
          },
        ],
      },
      translate: {
        unit: {
          0: "",
          1: "元",
          2: "萬",
          3: "單位",
        },
        currencytypeTW: {
          1: "元",
          2: "美元",
          3: "澳幣",
          4: "英鎊",
          5: "歐元",
          6: "紐幣",
          7: "港幣",
          8: "日幣",
          9: "人民幣",
          10: "南非幣",
        },
      },
      mvMaskContent: "",
      mvMaskOpen: false,
    };
  },
  methods: {
    init(){
      this.coverageAnnuals = this.getCoverageAnnuals();
      this.yearPeriod = this.coverageAnnuals.map((x) => x.value);
      this.showScheme =
        this.productData.schemeData && this.productData.schemeData.length
          ? true
          : false;
      if (this.showScheme) {
        this.schemeList = this.getScheme();
      }
      this.getCoverage();
      if (this.productData.currency != 1) {
        this.currencyId = this.productData.currency;
        const currencytext = this.translate.currencytypeTW[this.currencyId];
        const productunit = this.translate.unit[this.productData.unit];
        this.amountUnitLabel = `${productunit}(${currencytext})`;
        this.premiumUnitLabel = currencytext;
        this.policyValueUnitLabel = currencytext;
        this.minGuaranteeDieAmountUnitLabel = currencytext;
        this.minGuaranteeDueMoneyUnitLabel = currencytext;
        this.hiddenDisplayCurrencyText = currencytext;
      } else {
        this.amountUnitLabel = this.translate.unit[this.productData.unit];
      }
    },
    getProductTypeName(productType) {
      return this.options.productType.filter((x) => x.value == productType)[0]
        .name;
    },
    getContractTypeName(contractType) {
      return this.options.contractType.filter((x) => x.value == contractType)[0]
        .name;
    },
    formulaMantain() {
      if (
        this.productData.productType == "1" ||
        this.productData.productType == "4"
      ) {
        this.$router.push({ name: "CoverageFormulaSummary" }); //公式維護(傳統型、傳統型取大)
      } else if (
        this.productData.productType == "2" ||
        this.productData.productType == "3"
      ) {
        this.$router.push({ name: "InvestFormula" }); //公式維護(投資型、利率變動型)
      }
    },
    //日期格式化
    dashDateFormatter(date) {
      if (!date) {
        return "";
      }
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${date.getFullYear() - 1911}-${(m < 10 ? "0" : "") + m}-${(d < 10 ? "0" : "") + d}`;
    },
    //取得年期清單
    getCoverageAnnuals() {
      const res = [];
      this.productData.regularType
        .filter((item) => item.check)
        .forEach((item) => {
          const obj = {
            text:
              parseInt(item.year)
                .toString()
                .padStart(2, "0") + " ",
            value: parseInt(item.year) + "",
          };
          res.push(obj);
        });
      this.productData.maturityType
        .filter((item) => item.check)
        .forEach((item) => {
          const obj = {
            text:
              parseInt(item.year)
                .toString()
                .padStart(2, "0") + "歲",
            value: parseInt(item.year) + "@",
          };
          res.push(obj);
        });
      return res;
    },
    //取得計劃別清單
    getScheme() {
      const res = [];
      this.productData.schemeData.forEach((item) => {
        const obj = {
          value: item.name + "," + item.quantity,
          text: this.displayScheme(item),
        };
        res.push(obj);
      });
      return res;
    },
    //計畫別顯示字樣
    displayScheme(item) {
      if (item.name.indexOf("_1") > 0) {
        const schemeName = item.name.substring(0, item.name.length - 2);
        const quantityText = this.displayQuantity(item.quantity);
        return `計畫${schemeName}：${quantityText}`;
      } else {
        const schemeName = item.name;
        const quantityText = this.displayQuantity(item.quantity);
        return `計畫${schemeName}：日額${quantityText}`;
      }
    },
    //計畫別顯示單位
    displayQuantity(quantity) {
      if (quantity >= 10000) {
        const tenthousandNumber = quantity / 10000;
        return `${tenthousandNumber}萬元`;
      } else {
        return `${quantity}元`;
      }
    },
    //異動計畫別
    schemeChange() {
      const tokens = this.schemeId.split(",");
      this.amountTextBox = tokens[1];
    },
    //取得保障項目清單
    async getCoverage() {
      await getInvestFormulaSummary(
        this.$store.state.userInfo.id,
        this.productData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.coverageList = result.data.map(
            ({
              formulaname,
              investtype_formula_id,
            }) => {
              return {
                name: formulaname,
                id: investtype_formula_id,
              };
            }
          );
        }
      });

      if (this.productData.productType == "3") {
        const maturityBenefit = {
          name: "滿期保險金",
          id: "滿期保險金"
        }
        this.coverageList.push(maturityBenefit);
      }

      const set = new Set();
      this.coverageList = this.coverageList.filter(item => !set.has(item.name) ? set.add(item.name) : false);
      this.coverageId = this.coverageList.map((x) => x.name);
    },
    //異動幣別
    currencyChange() {
      if (this.currencyId != 1) {
        const currencytext = this.translate.currencytypeTW[this.currencyId];
        const productunit = this.translate.unit[this.productData.unit];
        this.amountUnitLabel = `${productunit}(${currencytext})`;
        this.premiumUnitLabel = currencytext;
        this.policyValueUnitLabel = currencytext;
        this.minGuaranteeDieAmountUnitLabel = currencytext;
        this.minGuaranteeDueMoneyUnitLabel = currencytext;
        this.hiddenDisplayCurrencyText = currencytext;
      } else {
        this.amountUnitLabel = this.translate.unit[this.productData.unit];
        this.premiumUnitLabel = "元";
        this.policyValueUnitLabel = "元";
        this.minGuaranteeDieAmountUnitLabel = "元";
        this.minGuaranteeDueMoneyUnitLabel = "元";
        this.hiddenDisplayCurrencyText = "";
      }
    },
    //參數檢查
    validateForm() {
      let isError = false;
      this.validate = this.$options.data().validate;
      if (this.showScheme && !this.schemeId) {
        isError = true;
        this.$toast.info({ title: "[計劃別]必須選擇" });
      }
      if (!this.ageTextBox) {
        isError = true;
        this.validate.isAgeNumberErr = true;
        this.$toast.info({ title: "[投保年齡]必須填寫" });
      }
      if (!this.amountTextBox) {
        isError = true;
        this.validate.isAmountNumberErr = true;
        this.$toast.info({ title: "[投保金額]必須填寫" });
      }
      if (!this.premiumTextBox) {
        isError = true;
        this.validate.isPremiumNumberErr = true;
        this.$toast.info({ title: "[保費]必須填寫" });
      }
      if (this.productData.productType == '3' && !this.annuityPayDate) {
        isError = true;
        this.validate.isAnnuityPayDateErr = true;
        this.$toast.info({ title: "[年金給付日]必須填寫" });
      }
      return isError;
    },
    //異動檢核內容
    coverageChange() {
      this.calculateTable = [];
      this.showResult = false;
    },
    //檢核
    async clickCheck() {
      if (this.validateForm()) return;
      this.mvMaskContent = "檢核中，請稍候...";
      this.panelOpen("mvMaskOpen");
      await this.calculationResult();
      this.panelClose("mvMaskOpen");
    },
    //試算公式
    async calculationResult() {
      let plans = [];
      const req = {
        age: this.ageTextBox,
        sex: "1",
        relation: "2",
        plans: plans,
      };

      let realAmount = this.amountTextBox * (this.productData.unit == "2" ? 10000 : this.productData.unit == "3" ? this.productData.unitPrice : 1);

      this.yearPeriod.forEach((item) => {
        let detail = [];
        let each = {
          yeartype: item,
          premium: this.premiumTextBox,
          contracttype: this.productData.contractType + "",
          payment: "4",
          insuredamount: realAmount + "",
          inscode: this.productData.insuranceCode,
          productId: this.productData.productId,
          CEPLCVL: this.insuranceValueTextBox,
          CEUNTAM: this.unitNoTextBox,
          GRT_DEAD_AMT: this.minGuaranteeDieAmountTextBox,
          GRT_MAT_AMT: this.minGuaranteeDueMoneyTextBox,
          DUE_AMT: this.deductionAmountTextBox,
          SUM_PAY_PREM: this.totalPremiumPaidTextBox,
          SUM_CRY_AMT: this.partialWithdrawalAmountTextBox,
        };
        if (this.productData.productType == "3") {
          each.anty_pay_date = moment(this.annuityPayDate).format("YYYY-MM-DD");
        }
        detail.push(each);
        plans.push(detail);
      });

      await calculateCoverage(req).then((result) => {
        if (result.header && result.header.status == "200") {
          const age = !this.ageTextBox ? 0 : this.ageTextBox;
          const calculationResult = this.takeCalculationResult(
            result.data.datalist
          );
          this.fillInDataSetWithColculationResult(age, calculationResult);
        } else {
          this.calculateTable = [];
          this.$toast.info({ title: result.header.message });
        }
        this.showResult = true;
      });
    },
    //計算結果依繳費年期暫存
    takeCalculationResult(resultList) {
      const addCoverage = ["生存保險金","健康檢查保險金","升學年金","滿期保險金"];
      let result = [];
      if (
        resultList &&
        resultList
          .flat()
          .filter((e) => this.coverageId.includes(e.coveragename)).length > 0
      ) {
        this.yearPeriod.forEach((item, index) => {
          result[item] = resultList[index].filter((each) =>
            this.coverageId.includes(each.coveragename)
          ).map(e => {
            // if(addCoverage.includes(e.coveragename)) {
            //   let period = e.coverageperiod.split(",");
            //   period = period.map(j => Number(j) + 1);
            //   e.coverageperiod = period.join(",");
            // }
            return e;
          });
        });
      }
      return result;
    },
    //暫存結果存入檢核結果資料表
    fillInDataSetWithColculationResult(age, calculationResult) {
      this.calculateTable = [];
      for (let e in calculationResult) {
        let hasValueCoverageResult = calculationResult[e];
        let year = 1; //第一年度
        let minKuoYear = new Date().getFullYear() - 1911; //民國年

        let table = this.genTableForEachCoverageResult(
          hasValueCoverageResult,
          age,
          year,
          minKuoYear
        );
        this.calculateTable[e] = table;
      }
    },
    //產生每繳費年期的計算結果
    genTableForEachCoverageResult(coverageResult, age, year, minKuoYear) {
      let table = [];
      let columns = this.buildTableHeader();
      if (coverageResult) {
        let totalRow = Math.max(
          ...coverageResult.map((p) => p.number),
          ...coverageResult.map((p) => Math.max(...p.coverageperiod.split(",")))
        );

        for (let row = 0; row < totalRow; row++) {
          let dataRow = [];
          dataRow[0] = Number(age) + row;
          dataRow[1] = Number(year) + row;
          dataRow[2] = Number(minKuoYear) + row;

          for (let i = 3; i < columns.length; i++) {
            let coverageName = columns[i];
            dataRow[i] = this.benefitToString(
              coverageResult.filter(
                (e) =>
                  e.coveragename == coverageName &&
                  e.coverageperiod.split(",").includes(dataRow[1] + "")
              )[0]
            );
          }
          table.push(dataRow);
        }
      }

      return table;
    },
    //產生計算結果表頭
    buildTableHeader() {
      let columns = [];
      columns[0] = "年齡";
      columns[1] = "年度";
      columns[2] = "民國年";
      let coverageCheckItem = this.coverageList.filter((each) =>
        this.coverageId.includes(each.name)
      );
      for (let x in coverageCheckItem) {
        columns[Number(x) + 3] = coverageCheckItem[x].name;
      }
      return columns;
    },
    //保費顯示格式
    benefitToString(coverage) {
      let result = "";

      if (coverage) {
        if (coverage.coveragemix > 0) {
          if (
            coverage.coveragemax > 0 &&
            coverage.coveragemix != coverage.coveragemax
          ) {
            result =
              Math.round(coverage.coveragemix).toLocaleString() +
              " ~ " +
              Math.round(coverage.coveragemax).toLocaleString();
          } else {
            result = Math.round(coverage.coveragemix).toLocaleString();
          }
        } else {
          result = Math.round(coverage.coveragemix).toLocaleString();
        }

        if (result == 0) result = "";
      }

      return result;
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.lh-40 {
  line-height: 40px;
}
.ml-5 {
  margin-left: 5px !important;
}
.searchArea {
  border-color: #027A39;
  border-width: 3px;
  background-color: white;
}

.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.clearDatepicker {
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}
</style>